import { Link, useLocation } from 'react-router-dom';
import { LogIn, ShieldAlert } from 'lucide-react';

/**
 * Écran affiché quand une page réservée n'obtient plus ses données.
 *
 * Sur téléphone, l'application installée reste ouverte des jours : la session
 * expire pendant ce temps, et le premier retour sur l'écran déclenche une
 * requête qui échoue. Afficher « Erreur 401 » n'apprend rien à personne — ce
 * qu'il faut, c'est le chemin pour se reconnecter, et le retour à la page
 * qu'on regardait.
 */
export default function SessionPerdue({ message }: { message?: string }) {
  const { pathname } = useLocation();
  const expiree = message === undefined || message.includes('401') || message.includes('Erreur 401');

  return (
    <div className="p-6 lg:p-10 text-center space-y-4 pb-24 lg:pb-0 max-w-md mx-auto">
      <ShieldAlert className="w-12 h-12 mx-auto text-amber-400" />

      <h1 className="text-xl font-bold text-gray-900 dark:text-gray-100">
        {expiree ? 'Session expirée' : 'Accès impossible'}
      </h1>

      <p className="text-gray-600 dark:text-gray-300">
        {expiree
          ? 'Votre connexion a expiré. Reconnectez-vous pour retrouver cette page.'
          : message}
      </p>

      <Link
        to={`/login?retour=${encodeURIComponent(pathname)}`}
        className="btn-primary w-full justify-center"
      >
        <LogIn className="w-5 h-5" />
        Se reconnecter
      </Link>

      <Link to="/" className="btn-outline w-full justify-center">
        Retour à l'accueil
      </Link>
    </div>
  );
}
